import { Navigate, Outlet } from "react-router-dom"

import type { RequireAuthProps } from "./RequireAuth.props"

export function RequireAuth({ isAuthenticated, redirectTo }: RequireAuthProps) {
  return isAuthenticated ? <Outlet /> : <Navigate to={redirectTo} replace />
}
